import { render, staticRenderFns } from "./ExtranetStatus.vue?vue&type=template&id=52674c9c"
import script from "./ExtranetStatus.vue?vue&type=script&lang=js"
export * from "./ExtranetStatus.vue?vue&type=script&lang=js"
import style0 from "./ExtranetStatus.vue?vue&type=style&index=0&id=52674c9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports